export default {
	propose:
		'Izveidojiet savu pasākumu un pārdodiet biļetes tiešsaistē, izmantojot teeko pakalpojumus!',
	description: 'Nepārspējamā pieredze sākas ar biļetes iegādi!',
	moreEvents: 'Rādīt vairāk notikumu',
	search: 'Meklēt'
}
